import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Header.style.css";
import logo from "../../assets/Logo/logo.png";
import { categories } from "../../data/categories";

const navClass = ({ isActive }) => (isActive ? "selected" : "");

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [portfolioOpen, setPortfolioOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Fermer les menus à chaque changement de page
  useEffect(() => {
    setMenuOpen(false);
    setPortfolioOpen(false);
  }, [location.pathname]);

  // Ombre sous l'en-tête dès qu'on a un peu défilé
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isPortfolio = location.pathname.startsWith("/portfolio");

  return (
    <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
      <div className="header-inner">
        <Link to="/home" className="logo">
          <img src={logo} alt="Pauline Limousin Photographies" className="logoImg" />
        </Link>
        <button
          className={`burger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
        <nav className={`navbar ${menuOpen ? "navbar-open" : ""}`}>
          <ul>
            <li>
              <NavLink to="/home" className={navClass}>
                ACCUEIL
              </NavLink>
            </li>
            <li className={`portfolio ${portfolioOpen ? "dropdown-open" : ""}`}>
              <button
                type="button"
                onClick={() => setPortfolioOpen((prev) => !prev)}
                className={`portfolio-toggle ${isPortfolio ? "selected" : ""}`}
                aria-expanded={portfolioOpen}
              >
                PORTFOLIO <span className="arrow-down"></span>
              </button>
              <ul className="dropdown">
                {categories.map((category) => (
                  <li key={category.slug}>
                    <NavLink
                      to={`/portfolio/${category.slug}`}
                      className={navClass}
                    >
                      {category.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
            <li>
              <NavLink to="/about" className={navClass}>
                MON HISTOIRE
              </NavLink>
            </li>
            <li>
              <NavLink to="/prestations" className={navClass}>
                TARIFS
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="nav-cta">
                RÉSERVER
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default React.memo(Header);
